import { Grid2 } from "@mui/material";
import CommunityBusinessTypeCard from "./CommunityBusinessTypeCard";
import { LocationCityOutlined, OfflineBoltOutlined } from "@mui/icons-material";
import useAuth from "hooks/useAuth";

const communityBusinessTypes = [
    {
        code: "aggregation",
        icon: <OfflineBoltOutlined />,
        name: "label.menu.powertrading",
        groups: ["INDIE_ADMIN", "ENERGY_AGENT_AGGRTN_USER"],
    },
    {
        code: "communities",
        icon: <LocationCityOutlined />,
        name: "label.menu.communities",
        groups: ["INDIE_ADMIN", "ENERGY_AGENT_EGAC_USER"],
    }
];

const CommunityBusinessTypeSelector = ({ handleBusinessTypeChange, currentBusinessType }) => {
    const { hasPermissionGroup } = useAuth();

    return (
        <Grid2 container spacing={2}>
            {communityBusinessTypes.map((type, index) => hasPermissionGroup(type.groups) && (
                <Grid2 key={index} item size={{xs:12, sm:6, md:4, lg:3}}>
                    <CommunityBusinessTypeCard 
                        code={type.code} 
                        icon={type.icon} 
                        title={type.name}
                        currentBusinessType={currentBusinessType} 
                        handleOnChange={handleBusinessTypeChange} 
                    />
                </Grid2>
            ))}
        </Grid2>
    )
}

export default CommunityBusinessTypeSelector;